var map = {
	"./arrow.svg": 4028,
	"./banner.svg": 2403,
	"./banners.svg": 4954,
	"./binding.svg": 4944,
	"./black_white_color.svg": 4196,
	"./brand_identity.svg": 5593,
	"./canvas.svg": 8761,
	"./chevron.svg": 2302,
	"./clips.svg": 9866,
	"./custom_design.svg": 513,
	"./customer.svg": 1753,
	"./design.svg": 2327,
	"./facebook.svg": 6921,
	"./instagram.svg": 3083,
	"./linkedin.svg": 8839,
	"./occasional_printing.svg": 9049,
	"./outdoor_advertising.svg": 304,
	"./photo-on-poster-and-on-dibond-privately.svg": 9921,
	"./pinterest.svg": 5849,
	"./plan_print.svg": 8264,
	"./posters_machines.svg": 290,
	"./presentation_material.svg": 1851,
	"./print-on-dibond-companies.svg": 4221,
	"./promo_material.svg": 3170,
	"./quality.svg": 3604,
	"./quote.svg": 5331,
	"./service.svg": 9054,
	"./sticker.svg": 7534,
	"./thesis.svg": 6381,
	"./twitter.svg": 6278,
	"./wave.svg": 4466,
	"./webatvantage.svg": 6188,
	"./wind-banners-beach-flags.svg": 7445,
	"./x.svg": 6959,
	"./yard-cloths.svg": 6805,
	"./youtube.svg": 4140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;